module.exports = __webpack_public_path__ + "static/media/sign.505f42f9.png";